import { BlurEvent, CityState, ClickEvent, Label, LookupModelSelectionEvent, TableRow, TableRowDisplayEvent, TableSelectionEvent } from "@mcleod/components";
import { ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutMobileCommPositionTable } from "./autogen/AutogenLayoutMobileCommPositionTable";
import { ActionButtonType, MobileCommPositionToolPanel } from "./MobileCommPositionToolPanel";

interface Coordinate {
    latitude: number;
    longitude: number;
}

export class MobileCommPositionTable extends AutogenLayoutMobileCommPositionTable {

    public _toolsPanel: MobileCommPositionToolPanel;
    public isFindNearData: boolean = false;
    searchList: () => void;
    removeCircle: () => void;

    onLoad(): void | Promise<void> {
        this._toolsPanel = new MobileCommPositionToolPanel(this, ActionButtonType.FINDNEAR, ActionButtonType.DISPATCH,
            ActionButtonType.REEFER_COMMANDS, ActionButtonType.REEFER_ALARMS);
        this.addLayoutLoadListener(event => {
            this.textboxCity.textCombined.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
                this.buttonFindNear.enabled = !StringUtil.isEmptyString(this.textboxRadius.text) && !StringUtil.isEmptyString(this.textboxCity.textCombined.text);
            });
        });

        this.setFindNearColumnVisible(false);
    }

    setFindNearColumnVisible(visible : boolean) {
        const findNearColumn = this.tableMobileCommPosition.columns.find(column => column.headingCell.id == "columnHeaderFindNear");
        this.tableMobileCommPosition.setColumnVisibility(findNearColumn, visible);
        this.tableMobileCommPosition.displayComponentData(null, this.tableMobileCommPosition.data, 0);
    }

    buttonFindNearOnClick(rows: TableRow[], event?: ClickEvent): any[] {
        this.buttonFindNear.busy = true;
        const cityState = this.textboxCity as CityState;
        const radius: number = +this.textboxRadius.text;
        const lat = cityState.textCombined.getFirstLookupModelData().get("latitude");
        const lng = cityState.textCombined.getFirstLookupModelData().get("longitude");
        const origin: Coordinate = { latitude: lat, longitude: -Math.abs(lng) };
        const findNearData = [];

        rows.forEach(tableRow => {
            const modelRow = tableRow.data as ModelRow;
            const lat = modelRow.get("latitude");
            const lng = modelRow.get("longitude");
            const dest: Coordinate = { latitude: lat, longitude: -Math.abs(lng) };
            const dist = this.calculateDistance(origin, dest);
            modelRow.set("find_near_dist", Math.round(dist));
            if (dist <= radius) {
                findNearData.push(modelRow);
            }
        });

        this.buttonFindNear.busy = false;
        return findNearData;
    }

    degreesToRadians(degrees: number): number {
        return degrees * Math.PI / 180;
    }

    calculateDistance(coord1: Coordinate, coord2: Coordinate): number {
        const earthRadiusKm = 6371;

        const lat1Rad = this.degreesToRadians(coord1.latitude);
        const lon1Rad = this.degreesToRadians(coord1.longitude);
        const lat2Rad = this.degreesToRadians(coord2.latitude);
        const lon2Rad = this.degreesToRadians(coord2.longitude);

        const latDiff = lat2Rad - lat1Rad;
        const lonDiff = lon2Rad - lon1Rad;

        const a = Math.sin(latDiff / 2) * Math.sin(latDiff / 2) +
            Math.cos(lat1Rad) * Math.cos(lat2Rad) *
            Math.sin(lonDiff / 2) * Math.sin(lonDiff / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const distance = earthRadiusKm * c;

        return distance;
    }

    textboxRadiusOnBlur(event: BlurEvent) {
        this.buttonFindNear.enabled = !StringUtil.isEmptyString(this.textboxRadius.text) && !StringUtil.isEmptyString(this.textboxCity.textCombined.text);
    }

    textboxCityOnBlur(event: BlurEvent) {
        this.buttonFindNear.enabled = !StringUtil.isEmptyString(this.textboxRadius.text) && !StringUtil.isEmptyString(this.textboxCity.textCombined.text);
    }

    tableMobileCommPositionOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const labelUnitType = tableRow.findComponentById("labelUnitType") as Label;
        labelUnitType.allowTooltip = false;
    }
}
